import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const preferenceApi = createAsyncThunk("preference", async () => {
  const response = await axiosInstance.get("/preference");
  return response.data;
});

const preferenceSlice = createSlice({
  name: "preference",
  initialState: {
    preference: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(preferenceApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(preferenceApi.fulfilled, (state, action) => {
        state.preference = action.payload;
        state.loading = false;
      })
      .addCase(preferenceApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default preferenceSlice.reducer;
